import axios from "axios"
import config from '../config'

var instance = axios.create({
    baseURL: config.api.URL,
    timeout: 10000
});

export const setToken = (token: string) => {
    instance = axios.create({
        baseURL: config.api.URL,
        timeout: 10000,
        headers: { Authorization: 'Bearer ' + token }
    });
}

const checkToken = () => {
    let token = localStorage.getItem('token');
    if (token) {
        setToken(token);
    }
}
checkToken();

export default () => {
    return instance;
}